export class PaymentRequestModel {
    name: string;
    phoneNumber: string;
    companyEmail: string;
    url: string;
    priceId: string;
    quantity: number;
}